import { useState } from "react";
import { cloneDeep } from "lodash";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { SummaryConfigurationSettings } from "@/Patient/Models/Settings/SummaryConfigurationSettings";
import { SummaryLayoutItem } from "@/Patient/Models/SummaryLayoutItem";
import { MedicalSummaryConfigurationActions } from "@/Patient/Stores/Actions/MedicalSummaryConfigurationActions";
import { MedicalSummaryConfigurationPopup } from "./MedicalSummaryConfigurationPopup";

interface IMedicalSummaryConfigurationProps {
    onConfigurationChange?: () => void
}

function MedicalSummaryConfiguration(props: IMedicalSummaryConfigurationProps): JSX.Element {
    const [showSummaryConfigurationPopup, setShowSummaryConfigurationPopup] = useState<boolean>(false);
    const { getText } = useTranslation();

    function onCloseSummaryConfigurationPopup(): void {
        props.onConfigurationChange();
        setShowSummaryConfigurationPopup(false);
    }

    function onOpenSummaryConfigurationPopup(): void {
        setShowSummaryConfigurationPopup(true);
    }

    async function saveSummaryConfiguration(layout: SummaryLayoutItem[], showProblemsDescription: boolean, patient: string = "default"): Promise<void> {
        const summaryConfigurationSettings = patient === "default" || !cacheStore.UserSettings?.SummaryConfigurationSettings
            ? new SummaryConfigurationSettings({ patient: showProblemsDescription }, { patient: layout })
            : cloneDeep(cacheStore.UserSettings?.SummaryConfigurationSettings);

        summaryConfigurationSettings.SummaryLayouts[patient] = layout;
        summaryConfigurationSettings.ShowProblemsDescription[patient] = showProblemsDescription;

        await MedicalSummaryConfigurationActions.save(summaryConfigurationSettings, sessionStore.userId);

        sessionStore.dispatch(LocalOperations.Misc.UpdateSummaryConfigurationSettings, {
            summaryConfigurationSettings
        });

        onCloseSummaryConfigurationPopup();
    }

    return (
        <div>
            <div className="margin-xs-top margin-sm-right align-right">
                <a
                    onClick={() => onOpenSummaryConfigurationPopup()}
                    data-cy="medicalNote-summary-configuration-button"
                >
                    {getText("ConfigureSummary_ButtonLabel")}
                </a>
            </div>
            {showSummaryConfigurationPopup && (
                <MedicalSummaryConfigurationPopup
                    onCancel={() => onCloseSummaryConfigurationPopup()}
                    onApplyToAllPatients={(layout, showProblemsDescription) => saveSummaryConfiguration(layout, showProblemsDescription)}
                    onApplyToCurrentPatient={(layout, showProblemsDescription, patientId) => saveSummaryConfiguration(layout, showProblemsDescription, patientId)}
                />
            )}
        </div>
    );
}

export { MedicalSummaryConfiguration };
